import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import BurgerMenu from '../../commons/BurgerMenu';
import { Button, Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import Header from '../../commons/Header';
import {
  ContFilterYear,
  ContFlexBetween,
  ContPaginationPage,
} from '../../styled-components';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import Footer from '../../commons/Footer';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconProfile } from '../../images/icn_profilo.svg';
import AlboTable from './AlboTable';
import EmailModal from './EmailModal';
import { ProfileStatus, ProfileTypes } from '../../lib/constants';
import SearchInput from '../../commons/SearchInput';
import { refactoringAdminLevels } from '../../lib/helpers/refactoringAdminLevels';
import regions from '../../lib/helpers/regions';

const AlboPresentational = ({
  data,
  total,
  query,
  onFilter,
  selected = [],
  onSelectChange,
  onSendEmail,
}) => {
  const [t] = useTranslation('ALBO');
  const { offset, limit, region, district } = query;
  const alert = useAlert();
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const toggleEmailModal = () => setIsEmailModalOpen((prev) => !prev);

  function getDistricts() {
    const currentRegion = region;
    const { capoluoghi = [] } =
      regions.find((r) => r.nome === currentRegion) || {};
    return capoluoghi;
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:ALBO')}
            icon={<IconProfile fill="#ffffff" style={{ height: '25px' }} />}
          />

          <Row>
            <Col sm="12" md="6" lg="4" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:TITLE_FILTER_TYPE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectYear"
                        name="year"
                        value={query.type || ''}
                        onChange={(e) => onFilter({ type: e.target.value })}
                      >
                        <option value="">Tutti</option>
                        {ProfileTypes.map((type) => (
                          <option value={type} key={type}>
                            {t(`CONTACTS:${refactoringAdminLevels(type)}`)}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="4" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Regione</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="region"
                        name="region"
                        value={region}
                        onChange={({ target: { value: region } }) => {
                          if (region === '') {
                            onFilter({ region: '', district: '' });
                          } else {
                            onFilter({ region });
                          }
                        }}
                      >
                        <option value="">Tutte</option>
                        {regions.map(({ nome }) => (
                          <option value={nome} key={nome}>
                            {nome}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="4" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Provincia</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="district"
                        name="district"
                        value={district}
                        onChange={({ target: { value: district } }) =>
                          onFilter({ district })
                        }
                        disabled={!region}
                      >
                        <option value="">Tutte</option>
                        {getDistricts().map((district) => (
                          <option value={district} key={district}>
                            {district}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col xs="12" md="6" lg="4" className="m-t-20 m-md-t-0">
              <SearchInput
                onFilter={onFilter}
                query={query}
                label={t('COMMON:SEARCH')}
              />
            </Col>
          </Row>
        </section>

        <section className="m-t-20">
          <AlboTable
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            selected={selected}
            onSelectChange={onSelectChange}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
        {selected.length > 0 && (
          <div className="text-right mb-3">
            <Button color="primary" onClick={toggleEmailModal}>
              Invia Email
            </Button>
          </div>
        )}

        <EmailModal
          isOpen={isEmailModalOpen}
          toggle={toggleEmailModal}
          selectedCount={selected.length}
          onSend={async (subject, body, cc) => {
            setIsSending(true);
            await onSendEmail(subject, body, cc);
            setIsSending(false);
            toggleEmailModal();
          }}
          isSending={isSending}
        />

        <Footer />
      </div>
    </div>
  );
};

export default AlboPresentational;
